import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  ENUM_STORAGES_LIST
} from "./actionTypes"
import {
  enumStoragesListSuccess,
  enumStoragesListError
} from "./actions"

import {
  apiGetEnumStoragesList,
} from "../../../api/calls/enums/storages"

function* enumStoragesList({payload: data}) {
  try {
    const response = yield call(apiGetEnumStoragesList, data)
    yield put(enumStoragesListSuccess(response))
  } catch (error) {
    yield put(enumStoragesListError(error))
  }
}

export function* watchEnumStoragesList() {
  yield takeEvery(ENUM_STORAGES_LIST, enumStoragesList);
}

function* enumStoragesSaga() {
  yield all([
    fork(watchEnumStoragesList),
  ]);
}

export default enumStoragesSaga
